module.exports = __webpack_public_path__ + "img/phone-right-icon-orange.9b267538.svg";